import React from "react";
import { Link } from "react-router-dom";

import SparkChart from "./SparkChart";
import DeviceRecentCallList from "./DeviceRecentCallList";

import { Card, CardContent, Grid, useTheme } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import { Box } from "@mui/system";

const useStyles = (theme) => ({
    card: {
        borderRadius: 0,
    },
    deviceId: {
        fontSize: ".9rem",
        fontWeight: "700",
        marginBottom: ".5rem",
        textDecoration: "none",
        color: "#1976d2",
        "&:visited": {
            color: "#1976d2",
        },
        [theme.breakpoints.down('xl')]: {
            fontSize: ".8rem",
        },
    },
    headerSubContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginRight: "10px",
    },
    indicatorContainer: {
        backgroundSize: "cover",
        filter: "progid: DXImageTransform.Microsoft.gradient(startColorstr = #e2e2e2, endColorstr = #fefefe, GradientType = 0)",
    },
    ledBox: {
        height: "30px",
        width: "30px",
        float: "left",
    },
    lidarButton: {
        position: "relative",
        color: "#1976d2",
        "&:hover": {
            cursor: "pointer",
            color: "#1976d2",
        },
        "&:visited": {
            color: "#1976d2",
        },
    },
});

export default function DashboardCardItem({
    d,
    deviceId,
    siteName,
    indicatorColor,
    fields,
    value,
    lineType,
    rowSize,
    getChartOverides,
    deviceType,
}) {
    const theme = useTheme();
    const classes = useStyles(theme);
    const pathUrlValues = [
        "telemetry/device-health/v3/",
        "telemetry/device-health/rtu/",
        "telemetry/device-health/polaris/",
    ];
    const pathUrl = value ? pathUrlValues[value] : "";

    const formatSiteName = () => {
        if (Array.isArray(siteName)) {
            return siteName.map((name, index) => (
                <span key={index}>
                    {name}
                    {<br />}
                </span>
            ));
        } else {
            return siteName;
        }
    };

    return (
        <Grid key={deviceId} item xs={12} sm={12} md={6} lg={rowSize}>
            <Card sx={classes.card}>
                <CardContent style={{ paddingBottom: "0" }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        {value === 1 ? (
                            <div>
                                <h3>
                                    ({deviceId}) {formatSiteName()}
                                </h3>
                            </div>
                        ) : (
                            <Link sx={classes.deviceId} to={{ pathname: pathUrl + deviceId }}>
                                <h3>
                                    ({deviceId}) {formatSiteName()}
                                </h3>
                            </Link>
                        )}

                        <Box component="div" sx={classes.headerSubContainer}>
                            <Box component="div" sx={classes.indicatorContainer}>
                                <Box component="div" sx={classes.ledBox}>
                                    <Box component="div" sx={indicatorColor} style={{ margin: "0 auto" }}></Box>
                                </Box>
                            </Box>
                            {value === 0 && (
                                <Tooltip title="View Point Cloud">
                                    <Link
                                        sx={classes.lidarButton}
                                        to={{ pathname: `/telemetry/device-health/lidar-view/${deviceId}` }}
                                    >
                                        <TrackChangesIcon />
                                    </Link>
                                </Tooltip>
                            )}
                        </Box>
                    </div>

                    <div style={{ height: "150px", width: "100%" }}>
                        <SparkChart
                            chartConfig={getChartOverides()}
                            device={d}
                            field={fields[value]}
                            lineType={lineType}
                        />
                    </div>

                    <DeviceRecentCallList deviceId={deviceId} d={d} deviceType={deviceType} />
                </CardContent>
            </Card>
        </Grid>
    );
}
